import { render, staticRenderFns } from "./DestinationCityBlock.vue?vue&type=template&id=21df11a7&"
import script from "./DestinationCityBlock.vue?vue&type=script&lang=js&"
export * from "./DestinationCityBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports